// Zentrale Transaktionstyp-Definitionen.
// Jeder Typ hat: label (DE), color, category, acquires (erzeugt Lots), disposes (verbraucht Lots), taxEvent

export const TX_TYPES = {
  // ── HANDEL ──────────────────────────────────────────────────────────────────
  kauf:          { label: 'Kauf',               color: '#2ECC71', category: 'trade',       acquires: true,  disposes: false, taxEvent: false },
  verkauf:       { label: 'Verkauf',             color: '#E4544A', category: 'trade',       acquires: false, disposes: true,  taxEvent: true  },
  swap:          { label: 'Tausch',              color: '#888BFF', category: 'trade',       acquires: true,  disposes: true,  taxEvent: true  },

  // ── TRANSFERS ────────────────────────────────────────────────────────────────
  einzahlung:    { label: 'Eingang',             color: '#60A5FA', category: 'transfer',    acquires: false, disposes: false, taxEvent: false },
  auszahlung:    { label: 'Ausgang',             color: '#94A3B8', category: 'transfer',    acquires: false, disposes: false, taxEvent: false },
  bridge:        { label: 'Bridge',              color: '#7DD3FC', category: 'transfer',    acquires: false, disposes: false, taxEvent: false },

  // ── EINKOMMEN ────────────────────────────────────────────────────────────────
  staking:       { label: 'Staking Reward',      color: '#F59E0B', category: 'income',      acquires: true,  disposes: false, taxEvent: false },
  airdrop:       { label: 'Airdrop',             color: '#A78BFA', category: 'income',      acquires: true,  disposes: false, taxEvent: false },
  mining:        { label: 'Mining Reward',        color: '#F97316', category: 'income',      acquires: true,  disposes: false, taxEvent: false },
  cashback:      { label: 'Cashback',            color: '#34D399', category: 'income',      acquires: true,  disposes: false, taxEvent: false },
  interest:      { label: 'Zinsen',              color: '#FCD34D', category: 'income',      acquires: true,  disposes: false, taxEvent: false },
  lending:       { label: 'Lending Reward',      color: '#6EE7B7', category: 'income',      acquires: true,  disposes: false, taxEvent: false },
  farming:       { label: 'Farming Reward',      color: '#86EFAC', category: 'income',      acquires: true,  disposes: false, taxEvent: false },

  // ── DERIVATE ─────────────────────────────────────────────────────────────────
  futures_open:  { label: 'Futures Eröffnung',   color: '#C084FC', category: 'derivatives', acquires: false, disposes: false, taxEvent: false },
  futures_close: { label: 'Futures Schließung',  color: '#F472B6', category: 'derivatives', acquires: false, disposes: false, taxEvent: true  },
  liquidation:   { label: 'Liquidation',         color: '#DC2626', category: 'derivatives', acquires: false, disposes: true,  taxEvent: true  },
  margin:        { label: 'Margin Trade',         color: '#E879F9', category: 'derivatives', acquires: false, disposes: false, taxEvent: true  },

  // ── SONSTIGES ────────────────────────────────────────────────────────────────
  burn:          { label: 'Burn',                color: '#EF4444', category: 'other',       acquires: false, disposes: true,  taxEvent: false },
  mint:          { label: 'Mint',                color: '#67E8F9', category: 'other',       acquires: true,  disposes: false, taxEvent: false },
  nft_buy:       { label: 'NFT Kauf',            color: '#2DD4BF', category: 'other',       acquires: true,  disposes: true,  taxEvent: false },
  nft_sell:      { label: 'NFT Verkauf',         color: '#FB7185', category: 'other',       acquires: false, disposes: true,  taxEvent: true  },
  gebuehr:       { label: 'Gebühr',              color: '#6B7280', category: 'fee',         acquires: false, disposes: false, taxEvent: false },
  // Verlust / Diebstahl / Hack — Lot wird verbraucht, gv = -ak (Totalverlust steuerlich)
  loss:          { label: 'Verlust',             color: '#991B1B', category: 'other',       acquires: false, disposes: true,  taxEvent: true  },
  // Realisierter PnL aus Futures/Margin (rein bilanziell, kein Lot-Effekt)
  futures_pnl:   { label: 'Futures PnL',         color: '#F472B6', category: 'derivatives', acquires: false, disposes: false, taxEvent: true  },
  // Funding-Fee (Perpetual-Swaps)
  funding_fee:   { label: 'Funding-Fee',         color: '#FB923C', category: 'derivatives', acquires: false, disposes: false, taxEvent: true  },
  unknown:       { label: 'Unbekannt',           color: '#6B7280', category: 'other',       acquires: false, disposes: false, taxEvent: false },
};

// Alle Einkommenstypen (empfangen Coins, erzeugen Lots zum Marktwert)
export const INCOME_TYPES = new Set([
  'staking', 'airdrop', 'mining', 'cashback', 'interest', 'lending', 'farming', 'mint',
]);

// Typen, die Lots erzeugen
export const ACQUIRES_TYPES = new Set(
  Object.entries(TX_TYPES).filter(([, v]) => v.acquires).map(([k]) => k)
);

// Typen, die Lots verbrauchen
export const DISPOSES_TYPES = new Set(
  Object.entries(TX_TYPES).filter(([, v]) => v.disposes).map(([k]) => k)
);

// ── Anzeige-Kategorie (Display) ───────────────────────────────────────────────
// WICHTIG: das ist NICHT der Engine-`typ`. Es ist die EINE Wahrheit, aus der die
// Tab-Leiste (WalletScreen) UND das Zeilen-Label lesen — damit sie nie wieder
// auseinanderlaufen (gematchter Transfer stand im Feed als „Transfer", aber im
// Tab unter „Einzahlung"). Rein Display: `typ`, FIFO, Bestand, matchTransfers,
// canonicalNormalizer bleiben unangetastet. `transferMap` = Ausgabe von
// buildTransferMap (NUR gelesen): enthält einen Eintrag für jede TX, die Teil
// eines Transfer-Paares ist ODER ein verbindbarer Near-Miss (plausibler
// Gegenpart). Eine Einzahlung OHNE solchen Eintrag ist ein gegenpartloser
// Zufluss (Airdrop/Reward) → eigene Kategorie statt „Transfer".
const DISPLAY_FIAT_SET = new Set(['EUR', 'USD', 'GBP', 'CHF', 'AUD', 'CAD', 'JPY', 'TRY', 'BRL']);
const FUTURES_DISPLAY_TYPES = new Set(['futures_open', 'futures_close', 'futures_pnl', 'funding_fee', 'liquidation', 'margin']);

// „Transfer" = bewiesener Move zwischen ZWEI EIGENEN Wallets (beide Beine geladen).
// Wahr, wenn adress-verifiziert (ownWalletTransfer) ODER ein Gegenstück erfasst/
// verbindbar in der transferMap liegt. Ein bewiesen EXTERNER Beleg
// (externalTransfer) ist KEIN Transfer → das Einzel-Bein bleibt gesendet/empfangen.
function isPairedTransfer(tx, transferMap) {
  if (tx?.ownWalletTransfer) return true;   // adress-verifiziert eigene↔eigene
  if (tx?.externalTransfer) return false;   // bewiesen extern → gesendet/empfangen
  const id = tx?._docId || String(tx?.id);
  const info = transferMap?.get?.(id);
  if (!info) return false;
  if (info.matchStatus === 'matched') return true; // bestätigtes Paar
  // 'unmatched' in der Map ist richtungs-asymmetrisch (buildTransferMap):
  // EINZAHLUNGEN landen dort NUR mit plausiblem Gegenpart (verbindbarer Near-Miss
  // → Transfer). AUSZAHLUNGEN werden dagegen IMMER geflaggt — auch ein einsamer
  // externer Versand → das ist KEIN Transfer, sondern „gesendet".
  if (info.matchStatus === 'unmatched') return tx?.typ === 'einzahlung' || tx?.typ === 'bridge';
  return false;
}

export function txDisplayCategory(tx, transferMap) {
  const typ = tx?.typ;
  if (typ === 'kauf')    return 'kauf';
  if (typ === 'verkauf') return 'verkauf';
  if (typ === 'swap')    return 'swap';

  const coin = String(tx?.coin || tx?.sym || '').toUpperCase();
  const isFiat = DISPLAY_FIAT_SET.has(coin);

  // Krypto-Abgang: eigenes Paar → 'transfer', sonst Einzel-Bein nach extern →
  // 'gesendet'. Fiat = Bank↔Börse-Cashflow (eigene Kategorie).
  if (typ === 'auszahlung') {
    if (isFiat) return 'fiat';
    return isPairedTransfer(tx, transferMap) ? 'transfer' : 'gesendet';
  }
  // Krypto-Zugang: eigenes Paar → 'transfer', sonst gegenpartloses Einzel-Bein →
  // 'empfangen'. INCOME_TYPES (Staking/Airdrop/…) fallen weiter unten in 'zufluss'.
  if (typ === 'einzahlung' || typ === 'bridge') {
    if (isFiat) return 'fiat';
    return isPairedTransfer(tx, transferMap) ? 'transfer' : 'empfangen';
  }

  if (INCOME_TYPES.has(typ)) return 'zufluss';
  if (FUTURES_DISPLAY_TYPES.has(typ)) return 'futures';

  // gebuehr / nft_* / loss / burn / mint / unknown → technisch/Sonstiges
  return 'sonstige';
}

export function getTxMeta(typ) {
  return TX_TYPES[typ] ?? TX_TYPES.unknown;
}

export function getTxLabel(typ) {
  return getTxMeta(typ).label;
}

export function getTxColor(typ) {
  return getTxMeta(typ).color;
}

// Ist `coin` eine Fiat-Währung? EINE zentrale Wahrheit (gleiche Liste wie
// txDisplayCategory), damit Display-, Edit- und Wizard-Layer Fiat identisch
// erkennen. Fiat-Ein/Auszahlungen (Bank↔Börse) sind bestandsneutral und erzeugen
// kein realisiertes Ergebnis — siehe einzahlung/auszahlung in TX_TYPES (taxEvent:false).
export function isFiatCoin(coin) {
  return DISPLAY_FIAT_SET.has(String(coin || '').toUpperCase());
}

// ── Typ-Icon-Pfade (Linien-Glyphen, viewBox 0 0 24 24) ────────────────────────
// EINE Quelle für die App-weiten Typ-Icons (Wizard-Chips, Edit-Raster, Income-
// Badges in TxRow, AssetDetail). Die Wizard-Datei hält aus historischen Gründen
// noch eine eigene Kopie der 10 erstellbaren Typen — die Werte hier sind 1:1
// identisch; zusätzlich decken wir die nur auto-erkannten Income-Typen ab.
export const TYPE_ICON_PATHS = {
  kauf:        'M12 3v13M12 16l6-6M12 16l-6-6',
  verkauf:     'M12 21V8M12 8l6 6M12 8l-6 6',
  swap:        'M4 9h13l-4-4M17 9l-4 4M20 15H7l4 4M7 15l4-4',
  einzahlung:  'M12 3v11M12 14l4-4M12 14l-4-4M4 19h16',
  auszahlung:  'M22 3L11 14M22 3l-7 19-4-8-8-4z',
  bridge:      'M3 16v-2a9 9 0 0 1 18 0v2M3 16h18M7 16v3M17 16v3',
  staking:     'M12 3l2.6 6.3 6.8.5-5.2 4.4 1.7 6.6-5.7-3.6-5.7 3.6 1.7-6.6-5.2-4.4 6.8-.5z',
  airdrop:     'M3 12a9 9 0 0 1 18 0M3 12l9 9.5 9-9.5M8.7 12L12 21.5M15.3 12L12 21.5',
  mining:      'M12 3l8 4.5v9L12 21l-8-4.5v-9zM4 7.5l8 4.5 8-4.5M12 12v9',
  cashback:    'M21 12a9 9 0 1 1-3.2-6.9M21 3v4h-4',
  interest:    'M22 7l-8.5 8.5-5-5L2 17M16 7h6v6',
  lending:     'M12 22V11M12 11C12 7.5 9.2 5.5 5 5.5c0 3.5 2.8 5.5 7 5.5zM12 11c0-3 2.4-5 6-5 0 3-2.4 5-6 5z',
  farming:     'M12 22V11M12 11C12 7.5 9.2 5.5 5 5.5c0 3.5 2.8 5.5 7 5.5zM12 11c0-3 2.4-5 6-5 0 3-2.4 5-6 5z',
  mint:        'M12 3l8 4.5v9L12 21l-8-4.5v-9zM4 7.5l8 4.5 8-4.5M12 12v9',
  futures_pnl: 'M7 4v3M7 13v3M4.5 7h5v6h-5zM16.5 6v3M16.5 15v3M14 9h5v6h-5z',
  funding_fee: 'M19 5L5 19M7.6 7.6a1.6 1.6 0 1 1 .01 0M16.4 16.4a1.6 1.6 0 1 1 .01 0',
  loss:        'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM8 12h8',
};

export function getTxIconPath(typ) {
  return TYPE_ICON_PATHS[typ] || null;
}

// ── Pastell-Typfarben (volle Badge-/Chip-Fläche, weiße Schrift + Icon) ─────────
// EINE Quelle für die Pastell-Badges (Import-/Wallet-Funde, TX-Liste, Wizard-Chips).
// Die 10 erstellbaren Typen tragen exakt die Werte der Wizard-Chips (WIZARD_TYPES);
// die nur auto-erkannten Typen (Income/Derivate/Transfer/Sonstiges) sind in
// derselben gedämpften Sättigung ergänzt, damit JEDER erkannte Typ ein Badge hat.
// Reine Darstellung — KEIN Engine-/FIFO-/Bestands-Effekt (Invarianten unberührt).
export const TYPE_PASTEL = {
  kauf:          '#5FB98A',
  verkauf:       '#DD7D72',
  swap:          '#8E90D6',
  einzahlung:    '#74A8DB',
  auszahlung:    '#E0976A',
  bridge:        '#7FB8C9',
  staking:       '#D9AE57',
  airdrop:       '#A78FD9',
  mining:        '#DDA15C',
  cashback:      '#6FC59A',
  interest:      '#D9C257',
  lending:       '#7FC8A8',
  farming:       '#8FCB8F',
  futures_open:  '#C39ED9',
  futures_close: '#DB8DB6',
  liquidation:   '#D0726B',
  margin:        '#D49ED9',
  burn:          '#D0726B',
  mint:          '#7FCBD0',
  nft_buy:       '#6FC4BC',
  nft_sell:      '#DB8FA0',
  gebuehr:       '#9BA3AE',
  loss:          '#C57371',
  futures_pnl:   '#DB8DB6',
  funding_fee:   '#DDA15C',
  unknown:       '#9BA3AE',
};

export function getTxPastel(typ) {
  return TYPE_PASTEL[typ] || TYPE_PASTEL.unknown;
}

// Mapping von CSV-Rohwerten auf kanonische Typen (mehrsprachig + Exchange-spezifisch)
export const TYPE_SYNONYMS = {
  // Deutsch
  kauf: 'kauf', kaufen: 'kauf', buy: 'kauf', purchase: 'kauf',
  verkauf: 'verkauf', verkaufen: 'verkauf', sell: 'verkauf', sale: 'verkauf',
  tausch: 'swap', swap: 'swap', trade: 'swap', convert: 'swap', conversion: 'swap',
  einzahlung: 'einzahlung', deposit: 'einzahlung', receive: 'einzahlung',
  empfangen: 'einzahlung', 'transfer in': 'einzahlung',
  auszahlung: 'auszahlung', withdrawal: 'auszahlung', send: 'auszahlung',
  senden: 'auszahlung', 'transfer out': 'auszahlung',
  bridge: 'bridge',
  staking: 'staking', 'staking reward': 'staking', 'staking rewards': 'staking',
  'staking income': 'staking', 'pos validator reward': 'staking',
  airdrop: 'airdrop', 'airdrop reward': 'airdrop',
  mining: 'mining', 'mining reward': 'mining', 'mining income': 'mining',
  cashback: 'cashback', 'crypto cashback': 'cashback', reward: 'cashback',
  interest: 'interest', zinsen: 'interest', 'savings interest': 'interest',
  'earn interest': 'interest', 'flexible savings interest': 'interest',
  'locked savings interest': 'interest',
  lending: 'lending', 'lending income': 'lending',
  farming: 'farming', 'liquidity mining': 'farming',
  'futures open': 'futures_open', 'futures entry': 'futures_open',
  'futures close': 'futures_close', 'futures exit': 'futures_close',
  liquidation: 'liquidation', 'forced liquidation': 'liquidation',
  margin: 'margin', 'margin trade': 'margin',
  burn: 'burn',
  mint: 'mint',
  'nft buy': 'nft_buy', 'nft purchase': 'nft_buy',
  'nft sell': 'nft_sell', 'nft sale': 'nft_sell',
  fee: 'gebuehr', gebuehr: 'gebuehr', gebühr: 'gebuehr', 'network fee': 'gebuehr',
  'transaction fee': 'gebuehr', 'withdraw fee': 'gebuehr', 'withdrawal fee': 'gebuehr',
  'trading fee': 'gebuehr', 'gas fee': 'gebuehr',

  // Binance-spezifisch
  'distribution': 'airdrop',
  'simple earn flexible interest': 'interest',
  'simple earn locked rewards': 'staking',
  'eth 2.0 staking rewards': 'staking',
  'launchpool interest': 'staking',
  'small assets exchange bnb': 'swap',
  'binance card cashback': 'cashback',
  'fiat deposit': 'einzahlung',
  'fiat withdrawal': 'auszahlung',

  // Ledger Live-spezifisch (Operation Type: IN / OUT / FEES)
  'in': 'einzahlung',
  'out': 'auszahlung',
  // FEES-Zeilen werden im Ledger-Parser übersprungen, hier als Sicherheitsnetz
  'fees': 'gebuehr',

  // Kraken-spezifisch
  'earn': 'staking',
  'transfer': 'einzahlung',
  'spend': 'swap',

  // Coinbase-spezifisch
  'rewards income': 'staking',
  'learning reward': 'airdrop',
  'advanced trade buy': 'kauf',
  'advanced trade sell': 'verkauf',

  // Bitget-spezifisch
  'spot trade': 'swap',
  'p2p buy': 'kauf',
  'p2p sell': 'verkauf',
  'futures trade': 'futures_close',
  'cross margin': 'margin',
  'isolated margin': 'margin',

  // Futures / Derivate (Binance, Bitget, Bybit etc.)
  'futures order': 'futures_close',
  'realize pnl': 'futures_pnl',
  'realized pnl': 'futures_pnl',
  'futures pnl': 'futures_pnl',
  'funding fee': 'funding_fee',
  'funding payment': 'funding_fee',
  'commission rebate': 'cashback',

  // Coinbase Pro / Advanced
  'pro fee': 'gebuehr',
  'advanced trade': 'swap',

  // Verlust / Diebstahl (manuell)
  loss: 'loss',
  stolen: 'loss',
  stolen_coins: 'loss',
  lost: 'loss',
  hack: 'loss',
  diebstahl: 'loss',
  verlust: 'loss',

  // Geschenke (manuell)
  gift_in: 'airdrop',
  gift: 'airdrop',
  geschenk: 'airdrop',
  payment_in: 'airdrop',
  gift_out: 'verkauf',
  payment_out: 'verkauf',
  payment: 'verkauf',
};

// Kategorie-Mapping für Filter-UI (z.B. ImportReviewScreen)
export const CATEGORY_LABELS = {
  trade:       'Handel',
  transfer:    'Transfer',
  fiat:        'Fiat',
  income:      'Einkommen',
  derivatives: 'Derivate',
  fee:         'Gebühr',
  other:       'Sonstiges',
};

export function getCategory(typ) {
  return getTxMeta(typ).category;
}

export function normalizeType(rawType) {
  if (!rawType) return 'unknown';
  const key = String(rawType).toLowerCase().trim();
  return TYPE_SYNONYMS[key] ?? 'unknown';
}
